"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _AccountDefaultsActions = require("../actions/AccountDefaultsActions");

var _fluxActions = require("flux-actions");

var _Modals = _interopRequireDefault(require("../constants/Modals"));

var _handleActions;

var initialState = null;

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _AccountDefaultsActions.AccountDefaultActionTypes.OPEN_MODAL, function (state, action) {
  return action.payload;
}), (0, _defineProperty2.default)(_handleActions, _AccountDefaultsActions.AccountDefaultActionTypes.CLOSE_MODAL, function () {
  return initialState;
}), (0, _defineProperty2.default)(_handleActions, _AccountDefaultsActions.SaveStagedChangesRequestTypes.SUCCESS + "||" + _AccountDefaultsActions.SaveStagedChangesRequestTypes.FAILURE, function _(state) {
  if (state === _Modals.default.SET_ACCOUNT_NAME) {
    return initialState;
  }

  return state;
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;